import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ShareDialogData, Tab } from './share-dialog-data.interface';
import { ShareDialogEmailForm } from './email-tab/share-dialog-email-form.interface';
import { OwnerInfo, ShareDialogSlackForm } from './slack-tab/slack-tab.interface';

@Component({
  selector: 'mode-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareDialogComponent implements OnInit {
  @Output() toggleExternalShare = new EventEmitter<boolean>();
  @Output() sendEmail = new EventEmitter<ShareDialogEmailForm>();
  @Output() sendSlackMessage = new EventEmitter<ShareDialogSlackForm>();
  @Output() scheduleDelivery = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  public tabs: readonly Tab[] = [Tab.Link, Tab.Slack, Tab.Email];
  public activeTab: Tab = Tab.Link;
  public tab = Tab;
  public reportRunStatus$: Observable<boolean | undefined> = of(false);
  public ownerInfo$: Observable<OwnerInfo> | undefined;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: {
      data$: Observable<ShareDialogData>;
      sendingEmail$: Observable<boolean>;
    }
  ) {}

  ngOnInit(): void {
    this.reportRunStatus$ = this.data.data$.pipe(map((data) => data.reportRunStatus.completed));
    this.ownerInfo$ = this.data.data$.pipe(
      map((data) => ({ membershipType: data.ownerMembershipType, username: data.ownerUsername }))
    );
  }
}
